import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_USER_SIZE = {
  ExtraSmall: "xs",
  Small: "sm",
  Medium: "md",
  Large: "lg",
  ExtraLarge: "xl",
  ExtraExtraLarge: "xxl",
} as const;

export type DSUserSize = ObjectValues<typeof DS_USER_SIZE>;
